import script from "./DownloadButtonPortfolioPdf.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadButtonPortfolioPdf.vue?vue&type=script&setup=true&lang=js"

import "./DownloadButtonPortfolioPdf.vue?vue&type=style&index=0&id=7e04d4a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e04d4a8"]])

export default __exports__